import TimePicker from './TimePicker';

export type { TimePickerProps } from './TimePicker';
export default TimePicker;
